import { ContactInterface } from 'src/interfaces/Contact'
import HTTPRequest from '../index'

const apiPathContact = '/api/v2/guests/contact'

class ContactRequest extends HTTPRequest {
  sendContact(value: ContactInterface) {
    return this.post<ContactInterface>(apiPathContact, value)
  }
}

export default new ContactRequest()
